import { render, staticRenderFns } from "./settlementList.vue?vue&type=template&id=1a8b2a68&scoped=true&"
import script from "./settlementList.vue?vue&type=script&lang=js&"
export * from "./settlementList.vue?vue&type=script&lang=js&"
import style0 from "./settlementList.vue?vue&type=style&index=0&id=1a8b2a68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b2a68",
  null
  
)

export default component.exports